import React, { useState } from "react";
import { useAuth } from "../../context/API_Client";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Snackbar,
  TextField,
  Alert,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import "../Login/login.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import CustomButton from "../../reusableComponents/CustomButton";

function ResetAndChangePassword({
  id,
  title,
  email,
  otp,
  mobileLayout,
  creating,
}) {
  const { updatePassword, changePassword } = useAuth();
  const { login, merchantSettings } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [paymentError, setPaymentError] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (id === "change_password") {
      customToast(
        "warning",
        "medium",
        "To enhance account security ,Our system has an automated policy for 90-days password updation. Please reset your password"
      );
    }
  }, []);

  const handleSnackbarOpen = () => {
    setOpenSnackbar(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleUpdateClick = (event) => {
    if (event) {
      event.preventDefault();
    }
    if (password === confirmPassword) {
      if (id !== "change_password") {
        updatePassword(
          { token: otp, email: email, password },
          (data) => {
            handleSnackbarOpen();
            if (creating) {
              login(
                email,
                password,
                () => {
                  merchantSettings(() => {
                    navigate("/adminProfile", { state: { firstTime: true } });
                  });
                },
                function (errorMsg) {
                  customToast("error", "high", errorMsg);
                }
              );
            } else window.location.href = "/";
          },
          (errorMsg) => {
            setPaymentError(errorMsg);
            customToast("error", "high", errorMsg);
            if (errorMsg?.response?.status === 400) {
              setOpenSnackbar(true);
            }
          }
        );
      } else {
        changePassword(
          email,
          {
            oldPassword: oldPassword,
            newPassword: confirmPassword,
          },
          function (data) {
            navigate("/home", { state: { firstTime: true } });
          },
          function (errorMsg) {
            customToast("error", "high", errorMsg);
          }
        );
      }
    } else {
      setPasswordsMatch(false);
    }
  };

  const [hasMinLength, setHasMinLength] = useState(false);
  const [hasUppercase, setHasUppercase] = useState(false);
  const [hasLowercase, setHasLowercase] = useState(false);
  const [hasSpecialChar, setHasSpecialChar] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasNoSequences, setHasNoSequences] = useState(false);
  const [validPassword, setValidPassword] = useState(false);

  useEffect(() => {
    if (password.length >= 8) setHasMinLength(true);
    else setHasMinLength(false);

    if (/[A-Z]/.test(password)) setHasUppercase(true);
    else setHasUppercase(false);

    if (/[a-z]/.test(password)) setHasLowercase(true);
    else setHasLowercase(false);

    if (/[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(password))
      setHasSpecialChar(true);
    else setHasSpecialChar(false);

    if (/\d/.test(password)) setHasNumber(true);
    else setHasNumber(false);

    if (
      !/(.)\1\1/.test(password) &&
      !/(012|123|234|345|456|567|678|789|890|210|321|432|543|654|765|876|987|098)/.test(
        password
      ) &&
      !/\s/.test(password)
    )
      setHasNoSequences(true);
    else setHasNoSequences(false);
  }, [password]);

  useEffect(() => {
    if (
      hasMinLength &&
      hasUppercase &&
      hasLowercase &&
      hasSpecialChar &&
      hasNumber &&
      hasNoSequences
    ) {
      setValidPassword(true);
    } else {
      setValidPassword(false);
    }
  }, [
    hasMinLength,
    hasUppercase,
    hasLowercase,
    hasSpecialChar,
    hasNumber,
    hasNoSequences,
  ]);

  const validatePassword = () => {
    return (
      hasMinLength &&
      hasUppercase &&
      hasLowercase &&
      hasSpecialChar &&
      hasNumber &&
      hasNoSequences
    );
  };

  return (
    <div sx={{ marginTop: mobileLayout ? "19px" : "23px" }}>
      <Typography className="login-main-title1">{title}</Typography>
      <Typography className="login-main-title2">
        Please setup your new password
      </Typography>
      {id === "change_password" && (
        <TextField
          fullWidth
          sx={{
            height: mobileLayout ? "40px !important" : "50px !important",
            marginTop: mobileLayout ? "20px" : "40px",
          }}
          placeholder="Old Password"
          type="password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
        />
      )}

      <TextField
        fullWidth
        sx={{
          height: mobileLayout ? "40px !important" : "50px !important",
          marginTop: mobileLayout ? "20px" : "40px",
        }}
        placeholder="New Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <div
        style={{
          justifyContent: "flex-start",
          marginTop: mobileLayout ? "6px" : "8px",
          padding: mobileLayout ? "8px" : "10px 16px 10px 16px",
          backgroundColor: "#FEFFE6",
          borderRadius: "6px",
          display: validatePassword() ? "none" : "flex",
          gap: "8px",
        }}
      >
        <img
          src="/assets/infoCircle.svg"
          alt="info"
          style={{ alignSelf: "baseline" }}
        />

        <div className="infoDescription">
          Password must:<br></br>
          <ul style={{ marginLeft: "20px", marginTop: "8px" }}>
            <p className="validation-field">
              <img
                src={hasMinLength ? "/assets/ticked.svg" : "/assets/unticked.svg"}
                style={{ height: "10px", width: "10px" }}
              />{" "}
              Be a minimum of 8 characters
            </p>
            <p className="validation-field">
              <img
                src={hasUppercase ? "/assets/ticked.svg" : "/assets/unticked.svg"}
                style={{ height: "10px", width: "10px" }}
              />{" "}
              Include an uppercase character
            </p>
            <p className="validation-field">
              <img
                src={hasLowercase ? "/assets/ticked.svg" : "/assets/unticked.svg"}
                style={{ height: "10px", width: "10px" }}
              />{" "}
              Include a lowercase character
            </p>
            <p className="validation-field">
              <img
                src={hasSpecialChar ? "/assets/ticked.svg" : "/assets/unticked.svg"}
                style={{ height: "10px", width: "10px" }}
              />{" "}
              Include a special character
            </p>
            <p className="validation-field">
              <img
                src={hasNumber ? "/assets/ticked.svg" : "/assets/unticked.svg"}
                style={{ height: "10px", width: "10px" }}
              />{" "}
              Include a number
            </p>
            <p className="validation-field">
              <img
                src={hasNoSequences ? "/assets/ticked.svg" : "/assets/unticked.svg"}
                style={{ height: "10px", width: "10px" }}
              />{" "}
              Not include spaces and sequences like (ABC, QWERTY, 123)
            </p>
          </ul>
        </div>
      </div>

      <OutlinedInput
        sx={{
          height: mobileLayout ? "40px !important" : "50px !important",
          marginTop: mobileLayout ? "20px" : "36px",
        }}
        fullWidth
        className="inputBoxWidth"
        // id="outlined-adornment-password"
        placeholder="Confirm Password"
        type={showPassword ? "text" : "password"}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              edge="end"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
      {confirmPassword !== password &&
        confirmPassword.length > 0 &&
        password.length > 0 ? (
        <div className="email-error">
          <img src="/assets/errorOutline.svg" />
          <Typography
            className="labelRegularRes"
            sx={{
              color: "#EA1238 !important",
            }}
          >
            The password doesn’t match
          </Typography>
        </div>
      ) : (
        <div className="email-error"></div>
      )}

      <CustomButton
        variant={"contained"}
        width={"100%"}
        color="primary"
        size={mobileLayout ? "xxl" : "xxxl"}
        text={creating ? "Setup Password" : "Update"}
        onClick={handleUpdateClick}
        disabled={
          password !== confirmPassword ||
          password?.length === 0 ||
          !validPassword
        }
      />

      <Snackbar
        open={openSnackbar}
        autoHideDuration={10000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          elevation={6}
          onClose={handleSnackbarClose}
          sx={{
            background:
              paymentError?.response?.status === 400
                ? "#D65745"
                : "var(--info-main, #5296D5)",
            border: "8px",
            color: "white",
            height: "64px",
            paddingTop: "14px",
          }}
        >
          {paymentError?.response?.status === 400 ? (
            <>
              <img
                src="/assets/warningSignRed.svg"
                alt="Logo"
                style={{ marginRight: "10px", marginTop: "-4px" }}
              />
              {paymentError?.response?.data?.fieldErrorItems[0].message}
            </>
          ) : (
            <>
              <img
                src="/assets/infoWhite.svg"
                alt="Logos"
                style={{ marginRight: "2px", marginTop: "-2px" }}
              />{" "}
              Your password has been updated
            </>
          )}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default ResetAndChangePassword;
